<template>
  <v-app>
    <v-progress-linear
      :indeterminate="loading"
      height="2" color="orange"
      style="margin: 0;z-index: 9999;position: fixed;"
    />
    <router-view></router-view>
    <!-- -->
    <v-snackbar
      :timeout="snackbar.timeout"
      :top="true"
      :multi-line="true"
      v-model="snackbar.show"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn flat icon class="mx-0" @click.native="snackbar.show = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'

  export default {
    name: 'App',
    data() {
      return {
        loading: false,

        snackbar: {
          show: false,
          timeout: 10000,
          text: '',
          color: 'error'
        }
      }
    },
    computed: {
      ...mapGetters([
        'authenticated'
      ])
    },

    // 注册异步请求响应的公共回调
    created() {
      // 响应拦截器
      const vm = this;
      Vue.axios.interceptors.response.use(
        function (response) {
          // 正常响应
          return response;
        },
        function (error) {
          // Do something with response error
          // console.log(error);
          const msg = error.response.data.message || "";
          vm.snackbar.text = "服务器错误[" + error.response.status + "]: " + msg;
          vm.snackbar.show = true;
          return Promise.reject(error);
        }
      );

      this.$router.beforeEach(
        (to, from, next) => {
          // console.log("in App $router.beforeEach");

          this.loading = true;
          next();
        });

      this.$router.afterEach(
        (to, from) => {
          this.loading = false;
        });
    }
  }
</script>
<style>
  .application {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue